<template>
  <CModal :show.sync="show" size="lg" color="primary" >
    <template #header>
      <CButtonClose @click="show=false" class="text-white"/>
    </template>

    <div class="text-center">
      <h1>Hola,</h1>
      <h5 class="pb-2">
        tus datos de facturación están sin rellenar. 
        Por favor, completa tus datos para poder descargar facturas
      </h5>

      <CButton color="outline-success" @click="goToFacturacion">
        Ir a datos de facturación <CIcon name="cil-arrow-thick-right" class="ml-2 mb-1"/>
      </CButton>
    </div>
    
    <template #footer-wrapper><span/></template>
  </CModal>
</template>

<script>
export default {
  name: 'StayingBillModal',
  props: {
    showModal: { type: Boolean, default: true }
  },
  computed: {
    show: {
      get: function() { return this.showModal },
      set: function(val) { this.$emit('update:showModal', val) }
    }
  },
  methods: {
    goToFacturacion() {
      this.$router.push('/configuracion/datos-factura')
    }
  }
}
</script>